import { render } from "./ProductScoreGood.vue?vue&type=template&id=dec995fc"
import script from "./ProductScoreGood.vue?vue&type=script&lang=js"
export * from "./ProductScoreGood.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__